import {
    TrendingUp,
    Zap,
    ShieldCheck,
    MousePointerClick,
    FileCheck2,
    Headset,
} from "lucide-react";
import { Reveal } from "./Reveal";

const FEATURES = [
    {
        icon: TrendingUp,
        title: "Best Exchange Rate",
        desc: "Competitive USDT to INR rates, fetched live so you always see the current value before you exchange.",
    },
    {
        icon: Zap,
        title: "Fast Processing",
        desc: "Simple and streamlined exchange process built to get your INR moving quickly.",
    },
    {
        icon: ShieldCheck,
        title: "Secure Transactions",
        desc: "Designed with security and authenticated processing in mind at every step.",
    },
    {
        icon: MousePointerClick,
        title: "Easy to Use",
        desc: "A simple exchange experience without unnecessary steps or confusing screens.",
    },
    {
        icon: FileCheck2,
        title: "Transparent Process",
        desc: "Clear rate and exchange flow — you always know what to expect before you start.",
    },
    {
        icon: Headset,
        title: "Customer Support",
        desc: "Assistance when you need help with your exchange, around the clock.",
    },
];

export default function WhyChoose() {
    return (
        <section
            id="why"
            data-testid="why-choose-section"
            className="relative py-16 md:py-24 scroll-mt-20"
        >
            <div className="pointer-events-none absolute -top-20 right-0 w-[400px] h-[400px] rounded-full bg-[#E3EEFF] blur-[120px]" />
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
                <Reveal>
                    <div className="max-w-2xl">
                        <span className="text-xs uppercase tracking-[0.25em] text-[#1E56FF] font-bold">
                            Why DtOrbit
                        </span>
                        <h2 className="font-display mt-3 text-3xl md:text-4xl font-bold tracking-tight text-[#0F1B3D]">
                            Why Choose DtOrbit for USDT to INR Exchange?
                        </h2>
                        <p className="mt-4 text-sm md:text-base text-[#5B6B8C] leading-relaxed">
                            A focused USDT to INR exchange experience built around
                            live rates, speed and security.
                        </p>
                    </div>
                </Reveal>

                <div className="mt-10 md:mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                    {FEATURES.map(({ icon: Icon, title, desc }, i) => (
                        <Reveal key={title} delay={(i % 3) * 100}>
                            <div
                                data-testid={`why-card-${i + 1}`}
                                className="glass card-hover rounded-2xl p-6 h-full"
                            >
                                <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-[#1E56FF] to-[#3EC6F0] shadow-[0_8px_24px_-8px_rgba(30,86,255,0.6)]">
                                    <Icon className="w-5 h-5 text-white" />
                                </span>
                                <h3 className="font-display mt-5 text-lg font-bold text-[#0F1B3D]">
                                    {title}
                                </h3>
                                <p className="mt-2 text-sm text-[#5B6B8C] leading-relaxed">
                                    {desc}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
